import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';


import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store/index";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  //TODO There was React.String mode I then changed it to Fragment

  <React.Fragment>
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        
          <App />
        
      </Provider>
    </BrowserRouter>
    </HelmetProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
